webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "dist/img/v-api@512.2c70ebf.png";

/***/ }),
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__(184);


// import axios from 'axios'


__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({
  fakeRequest: function fakeRequest() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function () {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(function () {
          return resolve(response);
        }, time);
      });
    };
  },
  fakeRequestError: function fakeRequestError() {
    var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1000;
    var response = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function () {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        setTimeout(function () {
          return reject(response);
        }, time);
      });
    };
  },
  giphyRandom: function giphyRandom() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('//api.giphy.com/v1/gifs/random', {
      params: {
        api_key: 'ceea3d73eee446f48e2a645e117b1f31',
        tag: params.tag,
        rating: params.rating
      }
    });
  },
  giphySearch: function giphySearch() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('//api.giphy.com/v1/gifs/search', {
      params: {
        api_key: 'ceea3d73eee446f48e2a645e117b1f31',
        q: params.q,
        limit: params.limit,
        offset: params.offset
      }
    });
  },
  hipolabsUni: function hipolabsUni(query) {
    return __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].http.get('//universities.hipolabs.com', {
      params: { query: query }
    });
  }
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(185);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VueApiRequestDemo_vue__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_VueApiRequestDemo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_VueApiRequestDemo_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CrossDomainCallback_vue__ = __webpack_require__(144);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_CrossDomainCallback_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_CrossDomainCallback_vue__);





__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    redirect: '/vue-api-request'
  }, {
    path: '/vue-api-request',
    component: __WEBPACK_IMPORTED_MODULE_2__components_VueApiRequestDemo_vue___default.a
  }, {
    path: '/cross-domain-callback',
    component: __WEBPACK_IMPORTED_MODULE_3__components_CrossDomainCallback_vue___default.a
  }]
}));

/***/ }),
/* 46 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(139)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(78),
  /* template */
  __webpack_require__(181),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(173),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    resource: ["resource () {\n  return Promise.resolve('myResponse')\n}\n", "<api-request :resource=\"resource\" v-model=\"response\"></api-request>\n", "response = 'myResponse'\n", "resource = {\n  foo: () => Promise.resolve('myFooResponse'),\n  bar: () => Promise.resolve('myBarResponse')\n}\n", "<api-request :resource=\"resource\" v-model=\"response\"></api-request>\n", "response = {\n  foo: 'myFooResponse'\n  bar: 'myBarResponse'\n}\n"],
    params: ["resource (myResponse) {\n  return Promise.resolve(myResponse)\n}\n", "<api-request :resource=\"resource\" :params=\"'Hello Vue'\"></api-request>\n", "resource = {\n  foo: (myFooResponse) => Promise.resolve(myFooResponse),\n  bar: (myBarResponse) => Promise.resolve(myBarResponse)\n}\n", "<api-request :resource=\"resource\" :params=\"{foo: 'Hello Foo', bar: 'Hello Bar'}\"></api-request>\n"],
    resp: ["response = {\n  foo: {\n    bar: {}\n  }\n}\n"]
  },
  slots: {
    default: ["<api-request>\n  <!--Success Slot-->\n</api-request>\n", "<api-request>\n  <div slot=\"waiting\">\n    <!--Waiting Slot-->\n  </div>\n  \n  <!--Not Success Slot-->\n  \n</api-request>\n"],
    waiting: ["<api-request>\n  <div slot=\"waiting\">\n    <!--Content before the call-->\n    <!--It keeps in this state until you fetch it-->\n    <!--After the call, the state returns to waiting-->\n  </div>\n</api-request>\n", "<api-request>\n  <div slot=\"waiting\">\n    <!--If the response is success, the content of success slot will appear-->\n    <!--If the response fails, the state returns to waiting because there is no error slot set-->\n  </div>\n  <div slot=\"success\">\n  </div>\n</api-request>\n"]
  },
  methods: {
    fetch: ["<api-request ref=\"myComponent\" :resource=\"myResource\" v-model=\"myResponse\">\n  <div slot=\"waiting\">\n    <button @click=\"$refs.myComponent.fetch()\">Request Now</button>\n  </div>\n  <div slot=\"success\">My stuffs to be shown</div>\n</api-request>\n", "myResource = {\n  foo: () => Promise.resolve(true),\n  bar: () => Promise.resolve(true)\n}\n", "<api-request ref=\"myComponent\" :resource=\"myResource\" v-model=\"myResponse\">\n  <div slot=\"waiting\">\n    <button @click=\"$refs.myComponent.fetch('foo')\">Request foo API Now</button>\n  </div>\n  <div slot=\"success\">My stuffs to be shown</div>\n</api-request>\n"]
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (["import Vue from 'vue'\nimport VueApiRequest from 'vue-api-request'\nVue.use(VueApiRequest)\n", "<api-request :resource=\"apiRequest\" v-model=\"apiResponse\">\n  My stuffs to be shown when the API loads\n</api-request>\n"]);

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([
/** Request Usage ***********************************************/
["<template>\n  <api-request :resource=\"giphyRandom\" v-model=\"myResponse\">\n    <img v-if=\"myResponse\" :src=\"myResponse.body.data.image_url\"/>\n  </api-request>\n</template>\n\n<script>\n  import Vue from 'vue'\n  import VueResource from 'vue-resource'\n  import VueApiRequest from 'vue-api-request'\n  \n  Vue.use(VueResource)\n  Vue.use(VueApiRequest)\n\n  export default {\n    data () {\n      return {\n        myResponse: null\n      }\n    },\n    methods: {\n      giphyRandom () {\n        return Vue.http.get('//api.giphy.com/v1/gifs/random', {\n          params: {\n            api_key: 'ceea3d73eee446f48e2a645e117b1f31'\n          }\n        })\n      }\n    }\n  }\n</script>\n"],
/** Request with Params ***********************************************/
["giphyRandom (tag) {\n  return Vue.http.get('//api.giphy.com/v1/gifs/random', {\n    params: {\n      api_key: 'ceea3d73eee446f48e2a645e117b1f31',\n      tag\n    }\n  })\n}\n", "<api-request :resource=\"giphyRandom\" params=\"food\" v-model=\"myResponse\">\n  <img v-if=\"myResponse\" :src=\"myResponse.body.data.image_url\"/>\n</api-request>\n", "giphyRandom (params = {}) {\n  return Vue.http.get('//api.giphy.com/v1/gifs/random', {\n    params: {\n      api_key: 'ceea3d73eee446f48e2a645e117b1f31',\n      tag: params.tag\n      rating: params.rating\n    }\n  })\n}\n", "<api-request \n  :resource=\"giphyRandom\" \n  :params=\"{tag: 'food', rating: 'g'}\" \n  v-model=\"myResponse\"\n>\n      <img v-if=\"myResponse\" :src=\"myResponse.body.data.image_url\"/>\n</api-request>\n"],
/** Fake Requests ***********************************************/
["<template>\n  <api-request :resource=\"fakeRequest\" :params=\"3000\" v-model=\"fakeResponse\">\n    Hello, I am a fake request and my response is: <code>{{fakeResponse}}</code>\n  </api-request>\n</template>\n\n<script>\n  import Vue from 'vue'\n  import VueApiRequest from 'vue-api-request'\n  \n  Vue.use(VueApiRequest)\n\n  export default {\n    data () {\n      return {\n        fakeResponse: null\n      }\n    },\n    methods: {\n      fakeRequest(time) {\n        return new Promise(resolve => {\n          setTimeout(() => resolve('My fake Request'), time)\n        })\n      }\n    }\n  }\n</script>\n"],
/** Global Request Access from $api ***********************************************/
["/** api.js **/\n\nimport Vue from 'vue'\nimport VueResource from 'vue-resource'\nimport axios from 'axios'\n\nVue.use(VueResource)\n\nexport default {\n  foo: (params) => Vue.http.get('/foo', {params}),\n  bar: (params) => axios.get('/bar', {params}),\n}\n", "import Vue from 'vue'\nimport VueApiRequest from 'vue-api-request'\nimport api from './api.js'\n\nVueApiRequest.setAPI(api)\nVue.use(VueApiRequest)\n", "<api-request\n  :resource=\"$api.foo\"\n  :params=\"{id:1}\"\n  v-model=\"foo\"\n>\n  My stuffs\n</api-request>\n\n<!--or-->\n\n<api-request\n  :resource=\"$api.bar\"\n  :params=\"{slug:'abc'}\"\n  v-model=\"bar\"\n>\n  My stuffs\n</api-request>\n"],
/** Trigger & Sync Requests using Waiting Slot ***********************************************/
["$api = {\n  fakeRequest: (params = {}) => new Promise(resolve => {\n    setTimeout(() => resolve(params.response), params.time)\n  })\n}\n", "<template>\n  <button @click=\"trigger=true\">\n\n    <api-request\n      :resource=\"$api.fakeRequest\"\n      :params=\"{time: 1000, response: !liked}\"\n      v-model=\"liked\"\n      :trigger.sync=\"trigger\"\n      :spinner-scale=\"0.55\"\n      :spinner-padding=\"0\"\n    >\n      <span slot=\"waiting\">\n          {{liked ? 'You liked' : 'Like'}}\n      </span>\n    </api-request>\n\n  </button>\n</template>\n\n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        trigger: false, //trigger always starts with false value\n        liked: false\n      }\n    }\n  }\n</script>\n", "$api = {\n  giphySearch: (params = {}) => Vue.http.get('//api.giphy.com/v1/gifs/search', {\n    params: {\n      api_key: 'ceea3d73eee446f48e2a645e117b1f31',\n      q: params.q,\n      limit: params.limit,\n      offset: params.offset\n    }\n  })\n}\n", "<template>\n  <api-request\n    :resource=\"$api.giphySearch\"\n    :params=\"{q, offset, limit: 3}\"\n    v-model=\"response\"\n    :trigger.sync=\"trigger\"\n    :sync=\"offset\"\n  >\n  \n    <form slot=\"waiting\" @submit.prevent=\"trigger=true\">\n      <input type=\"text\" placeholder=\"Type something\" v-model=\"q\"/>\n      <button>Search</button>\n    </form>\n    \n    <div slot=\"success\">\n      <div v-for=\"item in response.body.data\">\n        <img :src=\"item.images.fixed_width.url\"/>\n      </div>\n      \n      <div>\n        <span>\n          <button @click=\"offset -= offset == 0 ? 0:3\">Previous</button>\n        </span>\n        <span>\n          {{offset / 3 + 1}}\n        </span>\n        <span>\n          <button @click=\"offset += 3\">Next</button>\n        </span>\n      </div>\n    </div>\n    \n  </api-request>\n</template>\n\n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        trigger: false,\n        q: null,\n        offset: 0,\n        response: {\n          body: {}\n        }\n      }\n    }\n  }\n</script>\n", "computed: {\n  foobar () {\n    return [foo, bar]\n  }\n}\n"],
/** Conditional Request ***********************************************/
["$api = {\n  giphyRandom: () => Vue.http.get('//api.giphy.com/v1/gifs/random', {\n    params: { api_key: 'ceea3d73eee446f48e2a645e117b1f31' }\n  }),\n}\n", "<template>\n  <api-request\n    :resource=\"$api.giphyRandom\"\n    v-model=\"response\"\n    :trigger.sync=\"trigger\"\n    :only-if=\"canRefresh\"\n  >\n    <label>\n      <input type=\"checkbox\" v-model=\"canRefresh\"/> Can Refresh\n    </label>\n    <button @click=\"trigger=true\">Refresh GIF</button>\n\n    <img v-if=\"response\" :src=\"response.body.data.image_url\"/>\n  </api-request>\n</template>\n  \n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        trigger: false,\n        canRefresh: true,\n        response: null\n      }\n    }\n  }\n</script>\n"],
/** Using Events ***********************************************/
["$api = {\n  fakeRequest: (response) => new Promise(resolve => {\n    setTimeout(() => resolve(response), 1000)\n  }),\n  fakeRequestError: (response) => new Promise((resolve, reject) => {\n    setTimeout(() => reject(response), 1000)\n  })\n}\n", "<template>\n  <div>\n    <api-request\n      :resource=\"$api.fakeRequest\"\n      :trigger.sync=\"triggerWaiting\"\n      @waiting=\"waitingEvent\"\n    >\n      <div slot=\"waiting\">\n        <button @click=\"triggerWaiting=true\">Waiting Example</button>\n      </div>\n    </api-request>\n\n    <api-request\n      :resource=\"$api.fakeRequest\"\n      :trigger.sync=\"triggerLoading\"\n      @loading=\"loadingEvent\"\n    >\n      <div slot=\"waiting\">\n        <button @click=\"triggerLoading=true\">Loading Example</button>\n      </div>\n    </api-request>\n\n    <api-request\n      :resource=\"$api.fakeRequest\"\n      :params=\"'successResp'\"\n      :trigger.sync=\"triggerSuccess\"\n      @success=\"successEvent\"\n    >\n      <div slot=\"waiting\">\n        <button @click=\"triggerSuccess=true\">Success Example</button>\n      </div>\n      <div slot=\"success\">Success</div>\n    </api-request>\n\n    <api-request\n      :resource=\"$api.fakeRequestError\"\n      :params=\"'errorResp'\"\n      :trigger.sync=\"triggerError\"\n      @error=\"errorEvent\"\n    >\n      <div slot=\"waiting\">\n        <button @click=\"triggerError=true\">Error Example</button>\n      </div>\n      <div slot=\"error\">Error</div>\n    </api-request>\n\n    <api-request\n      :resource=\"$api.fakeRequest\"\n      :params=\"'loadedResp'\"\n      :trigger.sync=\"triggerLoaded\"\n      @loaded=\"loadedEvent\"\n    >\n      <div slot=\"waiting\">\n        <button @click=\"triggerLoaded=true\">Loaded Example</button>\n      </div>\n      <div slot=\"loaded\">Loaded</div>\n    </api-request>\n  </div>\n</template>\n\n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        triggerWaiting: false,\n        triggerLoading: false,\n        triggerSuccess: false,\n        triggerError: false,\n        triggerLoaded: false\n      }\n    },\n    methods: {\n      waitingEvent () {\n        alert('Request is waiting!')\n      },\n      loadingEvent () {\n        alert('Request is loading!')\n      },\n      successEvent (resp) {\n        alert('Success with response: ' + resp)\n      },\n      errorEvent (resp) {\n        alert('Error with response: ' + resp)\n      },\n      loadedEvent (resp) {\n        alert('Loaded (success or error) with response: ' + resp)\n      }\n    }\n  }\n</script>\n"],
/** Serial Request ***********************************************/
["$api = {\n  fakeRequest: (params = {}) => new Promise(resolve => {\n    setTimeout(() => resolve(params.response), params.time)\n  })\n}\n", "<template>\n  <api-request\n    :resource=\"$api.fakeRequest\"\n    :params=\"{time: 1000, response: 'First Response'}\"\n    v-model=\"response1\"\n    :trigger.sync=\"trigger\"\n    effect=\"flipInX\"\n  >\n    <div slot=\"waiting\">\n      <button @click=\"trigger=true\">Do serial request</button>\n    </div>\n\n    <div slot=\"success\">\n      <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n      <p>{{response1}}</p>\n\n      <api-request\n        :resource=\"$api.fakeRequest\"\n        :params=\"{time: 1500, response: 'Second Response'}\"\n        v-model=\"response2\"\n        effect=\"flipInY\"\n      >\n        <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n        <p>{{response2}}</p>\n\n        <api-request\n          :resource=\"$api.fakeRequest\"\n          :params=\"{time: 2000, response: 'Third Response'}\"\n          v-model=\"response3\"\n          effect=\"zoomIn\"\n        >\n          <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n          <p>{{response3}}</p>\n        </api-request>\n\n      </api-request>\n    </div>\n\n  </api-request>\n</template>\n\n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        response1: {},\n        response2: {},\n        response3: {},\n        trigger: false\n      }\n    }\n  }\n</script>\n"],
/** Parallel Request ***********************************************/
["$api = {\n  fakeRequest: (params = {}) => new Promise(resolve => {\n    setTimeout(() => resolve(params.response), params.time)\n  })\n}\n", "<template>\n  <api-request\n    :resource=\"resource\"\n    :params=\"{\n      request1: {time: 1000, response: 'First Response'}, \n      request2: {time: 2000, response: 'Second Response'}, \n      request3: {time: 3000, response: 'Third Response'}, \n    }\"\n    v-model=\"response\"\n    :trigger.sync=\"trigger\"\n  >\n    <form slot=\"waiting\">\n      <button @click=\"trigger=true\">Do parallel request</button>\n    </form>\n\n    <div slot=\"success\">\n      <span>\n        <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n        <br/>\n        {{response.request1}}\n      </span>\n      <span>\n        <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n        <br/>\n        {{response.request2}}\n      </span>\n      <span>\n        <img src=\"//ftgibran.github.io/static/v-api@512.png\"/>\n        <br/>\n        {{response.request3}}\n      </span>\n    </div>\n  </api-request>\n</template>\n\n<script>\n  // Don't forget to set your $api\n  export default {\n    data () {\n      return {\n        trigger: false,\n        response: {}\n      }\n    },\n    computed: {\n      resource () {\n        return {\n          request1: this.$api.fakeRequest,\n          request2: this.$api.fakeRequest,\n          request3: this.$api.fakeRequest\n        }\n      }\n    }\n  }\n</script>\n"],
/** Customize ***********************************************/
["import Vue from 'vue'\nimport VueApiRequest from 'vue-api-request'\nimport { TweenLite, Power2 } from 'gsap'\n\nVueApiRequest.addEffect('blur', el => {\n  el.style.filter = 'blur(20px)'\n  TweenLite.to(el, 1, {filter: 'blur(0)', ease: Power2.easeOut})\n})\n\nVue.use(VueApiRequest)\n", "<api-request\n  :resource=\"myResource\"\n  effect=\"blur\"\n>\n  <!--My stuffs to be shown-->\n</api-request>\n", "<!--CustomLoader.vue-->\n\n<template>\n  <div :style=\"{color: this.color}\">\n    <i class=\"fa fa-refresh fa-spin\"></i>\n    <strong>LOADING...</strong>\n  </div>\n</template>\n\n<script>\n  export default {\n    props: ['color']\n  }\n</script>\n", "import Vue from 'vue'\nimport VueApiRequest from 'vue-api-request'\nimport CustomLoader from './CustomLoader.vue'\n\nVueApiRequest.addLoader('CustomLoader', CustomLoader)\nVue.use(VueApiRequest)\n", "<api-request\n  :resource=\"myResource\"\n  spinner=\"CustomLoader\"\n>\n  <!--My stuffs to be shown-->\n</api-request>\n"]]);

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (input) {
  return "<api-request\n  :resource=\"myResource\"\n  effect=\"" + input.effect + "\"\n  spinner=\"" + input.spinner + "\"\n  spinner-color=\"" + input.spinnerColor + "\"\n  spinner-padding=\"" + input.spinnerPadding + "\"\n  :spinner-scale=\"" + input.spinnerScale + "\"\n>\n  <!--My stuffs to be shown-->\n</api-request>\n  ";
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (["$ npm i vue-api-request --save", "$ yarn add vue-api-request", "<script src=\"https://unpkg.com/vue-api-request@latest/dist/vue-api-request.min.js\"></script>\n<link href=\"https://unpkg.com/vue-api-request@latest/dist/vue-api-request.min.css\" rel=\"stylesheet\"/>\n"]);

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (["import Vue from 'vue'\nimport VueApiRequest from 'vue-api-request'\n\nlet options = {\n  effect: 'lightSpeedIn',\n  resp: 'body.foo.bar',\n  spinner: 'DotLoader',\n  spinnerColor: 'blue', //or #0000ff\n  spinnerPadding: '2em',\n  spinnerScale: 1.4,\n  onSuccess: resp => {\n    console.log('Success', resp)\n  },\n  onError: resp => {\n    alert(`Error: ${resp.message}`)\n  }\n}\n\nVue.use(VueApiRequest, options)\n", "<api-request\n  :resource=\"apiRequest\"\n  v-model=\"apiResponse\"\n  effect=\"lightSpeedIn\"\n  resp=\"body.foo.bar\"\n  spinner=\"DotLoader\"\n  spinner-color=\"blue\"\n  spinner-padding=\"2em\"\n  :spinner-scale=\"1.4\"\n  @success=\"successEvent\"\n  @error=\"errorEvent\"\n>\n  My stuffs to be shown when the API loads\n</api-request>\n"]);

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Installation__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BasicUsage__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PreConfiguration__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Docs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ApiReference__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FreeCustomize__ = __webpack_require__(55);







/* harmony default export */ __webpack_exports__["a"] = ({
  installation: __WEBPACK_IMPORTED_MODULE_0__Installation__["a" /* default */],
  basicUsage: __WEBPACK_IMPORTED_MODULE_1__BasicUsage__["a" /* default */],
  preConfiguration: __WEBPACK_IMPORTED_MODULE_2__PreConfiguration__["a" /* default */],
  docs: __WEBPACK_IMPORTED_MODULE_3__Docs__["a" /* default */],
  apiReference: __WEBPACK_IMPORTED_MODULE_4__ApiReference__["a" /* default */],
  freeCustomize: __WEBPACK_IMPORTED_MODULE_5__FreeCustomize__["a" /* default */]
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var firstExample = {
  show: true,
  response: {}
};

var fakeExample = {
  show: true,
  response: {}
};

var likeExample = {
  trigger: false,
  liked: false
};

var triggerExample = {
  show: true,
  trigger: false,
  q: null,
  offset: 0,
  response: {}
};

var conditionalExample = {
  trigger: false,
  canRefresh: true,
  response: null
};

var eventsExample = {
  show: false,
  triggerWaiting: false,
  triggerLoading: false,
  triggerSuccess: false,
  triggerError: false,
  triggerLoaded: false,
  waiting: function waiting() {
    return alert('Request is waiting!');
  },
  loading: function loading() {
    return alert('Request is loading!');
  },
  success: function success(resp) {
    return alert('Success with response: ' + resp);
  },
  error: function error(resp) {
    return alert('Error with response: ' + resp);
  },
  loaded: function loaded(resp) {
    return alert('Loaded (success or error) with response: ' + resp);
  }
};

var serialExample = {
  show: true,
  response1: {},
  response2: {},
  response3: {},
  trigger: false
};

var parallelExample = {
  show: true,
  resource: function resource(api) {
    return {
      request1: api.fakeRequest(1000, 'First Response'),
      request2: api.fakeRequest(2000, 'Second Response'),
      request3: api.fakeRequest(3000, 'Third Response')
    };
  },
  response: {},
  trigger: false
};

var customizeExample = {
  show: true,
  effect: 'lightSpeedIn',
  spinner: 'DotLoader',
  spinnerColor: '#FC6194',
  spinnerPadding: '60px',
  spinnerScale: 1.5
};

var customEffectExample = {
  show: true
};

var customSpinnerExample = {
  show: true

  /** Export ***********************************************/
};/* harmony default export */ __webpack_exports__["a"] = ({
  firstExample: firstExample,
  fakeExample: fakeExample,
  likeExample: likeExample,
  triggerExample: triggerExample,
  conditionalExample: conditionalExample,
  eventsExample: eventsExample,
  serialExample: serialExample,
  parallelExample: parallelExample,
  customizeExample: customizeExample,
  customEffectExample: customEffectExample,
  customSpinnerExample: customSpinnerExample
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__service_AppRouter__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__service_AppResource__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_font_awesome_css_font_awesome_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CustomLoader_vue__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_CustomLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_CustomLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_api_request__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_head__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_head__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.












if (true) {
  __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
    id: 'UA-75058768-2',
    router: __WEBPACK_IMPORTED_MODULE_2__service_AppRouter__["a" /* default */],
    autoTracking: {
      exception: true
    }
  });
}
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_9_vue_head___default.a);

__WEBPACK_IMPORTED_MODULE_8_vue_api_request__["a" /* default */].setAPI(__WEBPACK_IMPORTED_MODULE_3__service_AppResource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_8_vue_api_request__["a" /* default */].addLoader('CustomLoader', __WEBPACK_IMPORTED_MODULE_6__components_CustomLoader_vue___default.a);
__WEBPACK_IMPORTED_MODULE_8_vue_api_request__["a" /* default */].addEffect('blur', function (el) {
  el.style.filter = 'blur(20px)';
  __WEBPACK_IMPORTED_MODULE_4_gsap__["TweenLite"].to(el, 1, { filter: 'blur(0)', ease: __WEBPACK_IMPORTED_MODULE_4_gsap__["Power2"].easeOut });
});
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_8_vue_api_request__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__service_AppRouter__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App___default.a }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animate_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animate_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_GridLoader_vue__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_GridLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_GridLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_RiseLoader_vue__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_RiseLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_RiseLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_BeatLoader_vue__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_BeatLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_BeatLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader_vue__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_RotateLoader_vue__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_RotateLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_RotateLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_FadeLoader_vue__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_FadeLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_FadeLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_PacmanLoader_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_PacmanLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_PacmanLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SquareLoader_vue__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SquareLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SquareLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_ScaleLoader_vue__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_ScaleLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_ScaleLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_spinner_src_SkewLoader_vue__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_spinner_src_SkewLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_spinner_src_SkewLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_spinner_src_MoonLoader_vue__ = __webpack_require__(153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_spinner_src_MoonLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_spinner_src_MoonLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_spinner_src_RingLoader_vue__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_spinner_src_RingLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_spinner_src_RingLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_spinner_src_BounceLoader_vue__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_spinner_src_BounceLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_spinner_src_BounceLoader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_spinner_src_DotLoader_vue__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_spinner_src_DotLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_spinner_src_DotLoader_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



















/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    PulseLoader: __WEBPACK_IMPORTED_MODULE_2_vue_spinner_src_PulseLoader_vue___default.a,
    GridLoader: __WEBPACK_IMPORTED_MODULE_3_vue_spinner_src_GridLoader_vue___default.a,
    ClipLoader: __WEBPACK_IMPORTED_MODULE_4_vue_spinner_src_ClipLoader_vue___default.a,
    RiseLoader: __WEBPACK_IMPORTED_MODULE_5_vue_spinner_src_RiseLoader_vue___default.a,
    BeatLoader: __WEBPACK_IMPORTED_MODULE_6_vue_spinner_src_BeatLoader_vue___default.a,
    SyncLoader: __WEBPACK_IMPORTED_MODULE_7_vue_spinner_src_SyncLoader_vue___default.a,
    RotateLoader: __WEBPACK_IMPORTED_MODULE_8_vue_spinner_src_RotateLoader_vue___default.a,
    FadeLoader: __WEBPACK_IMPORTED_MODULE_9_vue_spinner_src_FadeLoader_vue___default.a,
    PacmanLoader: __WEBPACK_IMPORTED_MODULE_10_vue_spinner_src_PacmanLoader_vue___default.a,
    SquareLoader: __WEBPACK_IMPORTED_MODULE_11_vue_spinner_src_SquareLoader_vue___default.a,
    ScaleLoader: __WEBPACK_IMPORTED_MODULE_12_vue_spinner_src_ScaleLoader_vue___default.a,
    SkewLoader: __WEBPACK_IMPORTED_MODULE_13_vue_spinner_src_SkewLoader_vue___default.a,
    MoonLoader: __WEBPACK_IMPORTED_MODULE_14_vue_spinner_src_MoonLoader_vue___default.a,
    RingLoader: __WEBPACK_IMPORTED_MODULE_15_vue_spinner_src_RingLoader_vue___default.a,
    BounceLoader: __WEBPACK_IMPORTED_MODULE_16_vue_spinner_src_BounceLoader_vue___default.a,
    DotLoader: __WEBPACK_IMPORTED_MODULE_17_vue_spinner_src_DotLoader_vue___default.a
  },

  data: function data() {
    return {
      animate: null,
      state: null // waiting, loading, success, error
    };
  },


  props: {
    // Function type should return a promise and Object type must have these functions as values
    resource: {
      type: [Function, Object],
      required: true
    },
    params: null, // params to be add
    value: null, // v-model: response
    sync: null, // sync values that fetch request when it changes
    trigger: Boolean, // if true then it fetch
    onlyIf: { // condition to fetch
      type: Boolean,
      'default': true
    },
    effect: { // effect after load
      type: String,
      'default': 'fadeIn'
    },
    resp: { // default path response
      type: String,
      'default': '.'
    },
    spinner: { // type of spinner
      type: String,
      'default': 'ClipLoader'
    },
    spinnerColor: { // spinner color
      type: String,
      'default': '#42b983'
    },
    spinnerPadding: { // spinner padding
      type: [String, Number],
      'default': '1em'
    },
    spinnerScale: { // spinner scale
      type: Number,
      'default': 1
    }
  },

  computed: {
    hasLoadingSlot: function hasLoadingSlot() {
      return this.$slots.hasOwnProperty('loading');
    },
    hasWaitingSlot: function hasWaitingSlot() {
      return this.$slots.hasOwnProperty('waiting');
    },
    hasSuccessSlot: function hasSuccessSlot() {
      return this.$slots.hasOwnProperty('success');
    },
    hasErrorSlot: function hasErrorSlot() {
      return this.$slots.hasOwnProperty('error');
    },
    hasLoadedSlot: function hasLoadedSlot() {
      return this.$slots.hasOwnProperty('loaded');
    }
  },

  watch: {
    sync: function sync() {
      this.fetch();
    },
    trigger: function trigger(val) {
      if (val) {
        this.fetch();
        this.$emit('update:trigger', false);
      }
    }
  },

  mounted: function mounted() {
    if (this.trigger) this.$emit('update:trigger', false);
    if (this.hasWaitingSlot) this.waitingEvent();else this.fetch();
  },


  methods: {
    fetch: function fetch() {
      var _this = this;

      var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!this.onlyIf) return;

      // Go to loading state
      this.loadingEvent();

      var response = {};
      var resources = [];
      var keys = [];
      var path = this.resp;

      // if request is a single request then
      if (typeof this.resource === 'function') resources = [this.resource(this.params)];else if (key) {
        // if request has multiple requests and a specific key then
        keys.push(key);
        resources.push(this.resource[key](this.params && this.params[key]));
      } else {
        // if request has multiple requests then
        for (var _key in this.resource) {
          keys.push(_key);
          resources.push(this.resource[_key](this.params && this.params[_key]));
        }
      }

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(resources).then(function (responses) {
        // if request has multiple requests then
        if (keys.length !== 0) responses.forEach(function (resp, i) {
          response[keys[i]] = index(resp, path);
        });
        // if request is a single request then
        else responses.forEach(function (resp) {
            response = index(resp, path);
          });
        // Go to success state
        _this.successEvent(response);
      }).catch(function (resp) {
        // Go to error state
        _this.errorEvent(resp);
      });

      // Get Object by string dot notation
      function index(obj, is, value) {
        if (!is || is === '.') return obj;
        if (typeof is === 'string') return index(obj, is.split('.'), value);
        if (is.length === 1 && value !== undefined) {
          obj[is[0]] = value;
          return value;
        }
        if (is.length === 0) return obj;
        return index(obj[is[0]], is.slice(1), value);
      }
    },
    waitingEvent: function waitingEvent() {
      this.state = 'waiting';
      this.$emit('waiting');
    },
    loadingEvent: function loadingEvent() {
      this.state = 'loading';
      this.$emit('loading');
      this.animate = null;
    },
    successEvent: function successEvent(resp) {
      this.state = 'success';
      this.runEffect();
      this.$emit('input', resp);
      this.$emit('loaded', resp);
      this.$emit('success', resp);
      this.successCallback(resp);
      this.$emit('afterSuccess', resp);

      if (this.hasWaitingSlot && !(this.hasSuccessSlot || this.hasLoadedSlot)) this.waitingEvent();
    },
    errorEvent: function errorEvent(resp) {
      this.state = 'error';
      this.runEffect();
      this.$emit('loaded', resp);
      this.$emit('error', resp);
      this.errorCallback(resp);
      this.$emit('afterError', resp);

      if (this.hasWaitingSlot && !(this.hasErrorSlot || this.hasLoadedSlot)) this.waitingEvent();
    },
    runEffect: function runEffect() {
      var customEffect = this.customEffect(this.effect, this.$el);
      if (!customEffect) {
        this.animate = 'animated ' + this.effect;
      }
    },
    successCallback: function successCallback(resp) {},
    errorCallback: function errorCallback(resp) {},
    customEffect: function customEffect() {
      return null;
    }
  }

});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BeatLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'BounceLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        borderRadius: this.radius,
        opacity: 0.6,
        position: 'absolute',
        top: 0,
        left: 0
      }
    };
  },

  computed: {
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ClipLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '35px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        borderWidth: '2px',
        borderStyle: 'solid',
        borderColor: this.color + ' ' + this.color + ' transparent',
        borderRadius: this.radius,
        background: 'transparent !important'
      };
    }
  }
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'DotLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        backgroundColor: this.color,
        height: parseFloat(this.size) / 2 + 'px',
        width: parseFloat(this.size) / 2 + 'px',
        borderRadius: this.radius
      };
    },
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'FadeLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    height: {
      type: String,
      default: '15px'
    },
    width: {
      type: String,
      default: '5px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '2px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.height,
        width: this.width,
        margin: this.margin,
        borderRadius: this.radius
      },
      radius: '20px'
    };
  },

  computed: {
    ngRadius: function ngRadius() {
      return '-' + this.radius;
    },
    quarter: function quarter() {
      return parseFloat(this.radius) / 2 + parseFloat(this.radius) / 5.5 + 'px';
    },
    ngQuarter: function ngQuarter() {
      return '-' + this.quarter;
    },
    animationStyle1: function animationStyle1() {
      return {
        top: this.radius,
        left: 0,
        animationDelay: '0.12s'
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        top: this.quarter,
        left: this.quarter,
        animationDelay: '0.24s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        top: 0,
        left: this.radius,
        animationDelay: '0.36s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle4: function animationStyle4() {
      return {
        top: this.ngQuarter,
        left: this.quarter,
        animationDelay: '0.48s',
        transform: 'rotate(45deg)'
      };
    },
    animationStyle5: function animationStyle5() {
      return {
        top: this.ngRadius,
        left: 0,
        animationDelay: '0.60s'
      };
    },
    animationStyle6: function animationStyle6() {
      return {
        top: this.ngQuarter,
        left: this.ngQuarter,
        animationDelay: '0.72s',
        transform: 'rotate(-45deg)'
      };
    },
    animationStyle7: function animationStyle7() {
      return {
        top: 0,
        left: this.ngRadius,
        animationDelay: '0.84s',
        transform: 'rotate(90deg)'
      };
    },
    animationStyle8: function animationStyle8() {
      return {
        top: this.quarter,
        left: this.ngQuarter,
        animationDelay: '0.96s',
        transform: 'rotate(45deg)'
      };
    }
  }

});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'GridLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    animationStyle: function animationStyle() {
      return {
        animationName: 'v-gridStretchDelay',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease',
        animationFillMode: 'both',
        display: 'inline-block'
      };
    },
    animationStyle1: function animationStyle1() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle4: function animationStyle4() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle5: function animationStyle5() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle6: function animationStyle6() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle7: function animationStyle7() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle8: function animationStyle8() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    animationStyle9: function animationStyle9() {
      return {
        animationDelay: this.delay(),
        animationDuration: this.duration()
      };
    },
    containerStyle: function containerStyle() {
      return {
        width: parseFloat(this.size) * 3 + parseFloat(this.margin) * 6 + 'px',
        fontSize: 0
      };
    }
  },
  methods: {
    random: function random(value) {
      return Math.random() * value;
    },
    delay: function delay() {
      return this.random(100) / 100 - 0.2 + 's';
    },
    duration: function duration() {
      return this.random(100) / 100 + 0.6 + 's';
    }
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'MoonLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        height: this.size,
        width: this.size,
        borderRadius: this.radius
      }
    };
  },

  computed: {
    moonSize: function moonSize() {
      return parseFloat(this.size) / 7;
    },
    spinnerMoonStyle: function spinnerMoonStyle() {
      return {
        height: this.moonSize + 'px',
        width: this.moonSize + 'px',
        borderRadius: this.radius
      };
    },
    animationStyle2: function animationStyle2() {
      return {
        top: parseFloat(this.size) / 2 - this.moonSize / 2 + 'px',
        backgroundColor: this.color
      };
    },
    animationStyle3: function animationStyle3() {
      return {
        border: this.moonSize + 'px solid ' + this.color
      };
    }
  }

});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PacmanLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '25px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerDelay2: {
        animationDelay: '0.25s'
      },
      spinnerDelay3: {
        animationDelay: '0.50s'
      },
      spinnerDelay4: {
        animationDelay: '0.75s'
      },
      spinnerDelay5: {
        animationDelay: '1s'
      }
    };
  },

  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius
      };
    },
    border1: function border1() {
      return this.size + ' solid transparent';
    },
    border2: function border2() {
      return this.size + ' solid ' + this.color;
    },
    spinnerStyle1: function spinnerStyle1() {
      return {
        width: 0,
        height: 0,
        borderTop: this.border2,
        borderRight: this.border1,
        borderBottom: this.border2,
        borderLeft: this.border2,
        borderRadius: this.size
      };
    },
    animationStyle: function animationStyle() {
      return {
        width: '10px',
        height: '10px',
        transform: 'translate(0, ' + -parseFloat(this.size) / 4 + 'px)',
        position: 'absolute',
        top: '25px',
        left: '100px',
        animationName: 'v-pacmanStretchDelay',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'linear',
        animationFillMode: 'both'
      };
    }
  }

});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'PulseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        width: this.size,
        height: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-pulseStretchDelay',
        animationDuration: '0.75s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.12s'
      },
      spinnerDelay2: {
        animationDelay: '0.24s'
      },
      spinnerDelay3: {
        animationDelay: '0.36s'
      }
    };
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'RingLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '60px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  computed: {
    spinnerStyle: function spinnerStyle() {
      return {
        height: this.size,
        width: this.size,
        border: parseFloat(this.size) / 10 + 'px solid' + this.color,
        opacity: 0.4,
        borderRadius: this.radius
      };
    },
    spinnerBasicStyle: function spinnerBasicStyle() {
      return {
        height: this.size,
        width: this.size,
        position: 'relative'
      };
    }
  }

});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'RiseLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  }
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'RotateLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius
      }
    };
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'ScaleLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    height: {
      type: String,
      default: '35px'
    },
    width: {
      type: String,
      default: '4px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '2px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.height,
        width: this.width,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-scaleStretchDelay',
        animationDuration: '1s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'cubic-bezier(.2,.68,.18,1.08)',
        animationFillMode: 'both'
        // TODO 
        // animation: ['sk-waveStretchDelay', '1s', 'infinite', 'cubic-bezier(.2,.68,.18,1.08)'].join(' '),
        // animationFillMode: "both"
      },
      spinnerDelay1: {
        animationDelay: '0.1s'
      },
      spinnerDelay2: {
        animationDelay: '0.2s'
      },
      spinnerDelay3: {
        animationDelay: '0.3s'
      },
      spinnerDelay4: {
        animationDelay: '0.4s'
      },
      spinnerDelay5: {
        animationDelay: '0.5s'
      }
    };
  }
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SkewLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '20px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        height: 0,
        width: 0,
        borderLeft: this.size + ' solid transparent',
        borderRight: this.size + ' solid transparent',
        borderBottom: this.size + ' solid ' + this.color
      }
    };
  }
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SquareLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '50px'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size
      }
    };
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({

  name: 'SyncLoader',

  props: {
    loading: {
      type: Boolean,
      default: true
    },
    color: {
      type: String,
      default: '#5dc596'
    },
    size: {
      type: String,
      default: '15px'
    },
    margin: {
      type: String,
      default: '2px'
    },
    radius: {
      type: String,
      default: '100%'
    }
  },
  data: function data() {
    return {
      spinnerStyle: {
        backgroundColor: this.color,
        height: this.size,
        width: this.size,
        margin: this.margin,
        borderRadius: this.radius,
        display: 'inline-block',
        animationName: 'v-syncStretchDelay',
        animationDuration: '0.6s',
        animationIterationCount: 'infinite',
        animationTimingFunction: 'ease-in-out',
        animationFillMode: 'both'
      },
      spinnerDelay1: {
        animationDelay: '0.07s'
      },
      spinnerDelay2: {
        animationDelay: '0.14s'
      },
      spinnerDelay3: {
        animationDelay: '0.21s'
      }
    };
  }
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'App',
  created: function created() {
    console.info('v' + __WEBPACK_IMPORTED_MODULE_0__package_json__["version"]);
  }
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      local: null,
      origin: null,
      data: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.local = document.location.origin;
    window.onmessage = function (e) {
      if (e.origin !== document.location.origin) {
        _this.origin = e.origin;
        _this.data = e.data;
      }
    };
  }
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  props: ['color']
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prismjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prismjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prismjs_themes_prism_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__codes_VueApiRequestDemo_code__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__examples_VueApiRequestDemo__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_gsap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_gsap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap_ScrollToPlugin__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_gsap_ScrollToPlugin___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_gsap_ScrollToPlugin__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// Clone Example
var defaultSet = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(__WEBPACK_IMPORTED_MODULE_5__examples_VueApiRequestDemo__["a" /* default */]));

/* harmony default export */ __webpack_exports__["default"] = ({
  head: {
    title: {
      inner: 'Vue API Request'
    }
  },

  data: function data() {
    return { code: __WEBPACK_IMPORTED_MODULE_4__codes_VueApiRequestDemo_code__["a" /* default */], example: __WEBPACK_IMPORTED_MODULE_5__examples_VueApiRequestDemo__["a" /* default */] };
  },


  methods: {
    js: function js(code) {
      return __WEBPACK_IMPORTED_MODULE_2_prismjs___default.a.highlight(code, __WEBPACK_IMPORTED_MODULE_2_prismjs___default.a.languages.javascript);
    },
    html: function html(code) {
      return __WEBPACK_IMPORTED_MODULE_2_prismjs___default.a.highlight(code, __WEBPACK_IMPORTED_MODULE_2_prismjs___default.a.languages.html);
    },
    scrollTo: function scrollTo(query) {
      __WEBPACK_IMPORTED_MODULE_6_gsap__["TweenLite"].to(window, 1, { scrollTo: query });
    },
    reset: function reset(name) {
      var _this = this;

      var soft = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!soft) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.example[name]).forEach(function (item) {
          var value = defaultSet[name][item];
          if (value !== undefined) _this.example[name][item] = value;
        });
      }

      this.example[name].show = false;
      this.$nextTick(function () {
        _this.example[name].show = true;
      });
    }
  }
});

/***/ }),
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 121 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 125 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 127 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 128 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 130 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 131 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 132 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 135 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 136 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 138 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 139 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 140 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 141 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 142 */,
/* 143 */,
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(79),
  /* template */
  __webpack_require__(171),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(128)
  __webpack_require__(129)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(81),
  /* template */
  __webpack_require__(169),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3f0306b1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(141)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(61),
  /* template */
  __webpack_require__(183),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(134)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(176),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(140)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(63),
  /* template */
  __webpack_require__(182),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(133)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(64),
  /* template */
  __webpack_require__(175),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(136)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(178),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(135)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(66),
  /* template */
  __webpack_require__(177),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(126)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(67),
  /* template */
  __webpack_require__(167),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(132)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(174),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(131)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(69),
  /* template */
  __webpack_require__(172),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(130)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(70),
  /* template */
  __webpack_require__(170),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(124)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(165),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(123)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(72),
  /* template */
  __webpack_require__(164),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(125)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(73),
  /* template */
  __webpack_require__(166),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(122)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(163),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(127)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(75),
  /* template */
  __webpack_require__(168),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(138)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(76),
  /* template */
  __webpack_require__(180),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(137)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(179),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 163 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-scale v-scale1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-scale v-scale2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-scale v-scale3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  }), _c('div', {
    staticClass: "v-scale v-scale4",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay4])
  }), _c('div', {
    staticClass: "v-scale v-scale5",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay5])
  })])
},staticRenderFns: []}

/***/ }),
/* 164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-rise v-rise-odd",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-rise v-rise-even",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-rise v-rise-odd",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-rise v-rise-even",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-rise v-rise-odd",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-ring v-ring1",
    style: (_vm.spinnerBasicStyle)
  }, [_c('div', {
    staticClass: "v-ring v-ring2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-ring v-ring3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 166 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-rotate v-rotate1",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "v-rotate v-rotate2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-rotate v-rotate3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 167 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner",
    style: (_vm.containerStyle)
  }, [_c('div', {
    staticClass: "v-grid v-grid1",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle1])
  }), _c('div', {
    staticClass: "v-grid v-grid2",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle2])
  }), _c('div', {
    staticClass: "v-grid v-grid3",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle3])
  }), _c('div', {
    staticClass: "v-grid v-grid4",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle4])
  }), _c('div', {
    staticClass: "v-grid v-grid5",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle5])
  }), _c('div', {
    staticClass: "v-grid v-grid6",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle6])
  }), _c('div', {
    staticClass: "v-grid v-grid7",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle7])
  }), _c('div', {
    staticClass: "v-grid v-grid8",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle8])
  }), _c('div', {
    staticClass: "v-grid v-grid9",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.animationStyle9])
  })])
},staticRenderFns: []}

/***/ }),
/* 168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-skew",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', [_c('section', {
    attrs: {
      "id": "home"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('api-request', {
    staticClass: "full-width",
    attrs: {
      "resource": _vm.$api.fakeRequest(2000),
      "effect": "lightSpeedIn",
      "spinner": "DotLoader",
      "spinner-color": "#FC6194",
      "spinner-scale": 2
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col col-md-8 col-md-offset-2"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16),
      "alt": "Vue Api Request"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "v-api-logo"
  }, [_vm._v("API REQUEST")]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "effect": "zoomIn",
      "spinner": "SyncLoader",
      "spinner-color": "#FC6194",
      "spinner-scale": 1,
      "spinner-padding": "32px"
    }
  }, [_c('h1', [_vm._v("Documentation")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(3500),
      "effect": "bounceIn",
      "spinner": "MoonLoader",
      "spinnerColor": "#FC6194",
      "spinnerScale": 0.7,
      "spinnerPadding": "8px"
    }
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        _vm.scrollTo('#summary')
      }
    }
  }, [_vm._v("\n                Getting Started & Examples\n              ")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-info btn-lg",
    attrs: {
      "href": "//github.com/ftgibran/vue-api-request",
      "target": "_blank"
    }
  }, [_vm._v("\n                View on Github\n              ")])])], 1)])])], 1)]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "summary"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Summary")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    staticClass: "row"
  }, [_c('ul', {
    staticClass: "list-unstyled col-md-6 col-md-offset-3"
  }, [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#getting-started')
      }
    }
  }, [_vm._v("Getting Started")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#installation')
      }
    }
  }, [_vm._v("Installation")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#basic-usage')
      }
    }
  }, [_vm._v("Basic Usage")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#pre-configuration')
      }
    }
  }, [_vm._v("Pre Configuration")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#explanations')
      }
    }
  }, [_vm._v("Explanations & Examples")]), _vm._v(" "), _c('ol', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_1')
      }
    }
  }, [_vm._v("First Step")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_2')
      }
    }
  }, [_vm._v("Request with Params")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_3')
      }
    }
  }, [_vm._v("Fake Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_4')
      }
    }
  }, [_vm._v("Global Request Access from $api")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_5')
      }
    }
  }, [_vm._v("Trigger & Sync Requests using Waiting Slot")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_6')
      }
    }
  }, [_vm._v("Conditional Request")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_7')
      }
    }
  }, [_vm._v("Using Events")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_8')
      }
    }
  }, [_vm._v("Serial Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_9')
      }
    }
  }, [_vm._v("Parallel Requests")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_10')
      }
    }
  }, [_vm._v("Customize")])])])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#api')
      }
    }
  }, [_vm._v("API Reference")]), _vm._v(" "), _c('ul', [_c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("Props")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("Events")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#slots')
      }
    }
  }, [_vm._v("Slots")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods')
      }
    }
  }, [_vm._v("Methods")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-methods')
      }
    }
  }, [_vm._v("Configuration Methods")])]), _vm._v(" "), _c('li', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-options')
      }
    }
  }, [_vm._v("Configuration Options")])])])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "getting-started"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Getting Started")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "installation"
    }
  }, [_c('h3', [_vm._v("Installation")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.code['installation'][0])
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.code['installation'][1])
    }
  }), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['installation'][2]))
    }
  }), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "basic-usage"
    }
  }, [_c('h3', [_vm._v("Basic Usage")]), _vm._v(" "), _c('p', [_vm._v("\n          You have to import the library and use as a Vue plugin to enable the functionality globally on all components.\n        ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['basicUsage'][0]))
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['basicUsage'][1]))
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "pre-configuration"
    }
  }, [_c('h3', [_vm._v("Pre Configuration")]), _vm._v(" "), _c('p', [_vm._v("\n          You may also set your own default configuration, so you don't need to customize every time each ApiRequest component. You are still able to customize a specific component using props.\n          Go to section "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-options')
      }
    }
  }, [_vm._v("API - Configuration Options")]), _vm._v(" to further information.\n        ")]), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['preConfiguration'][0]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n          The 'options' variable above is equivalent of:\n        ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['preConfiguration'][1]))
    }
  })])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "explanations"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("Explanations & Examples")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_1"
    }
  }, [_c('h3', [_vm._v("1. First Step")]), _vm._v(" "), _c('p', [_vm._v("\n          Vue API Request provides a full control on your APIs, making the calls simple, fast and easy to implement.\n          Also, your code will be cleaner and more elegant.\n        ")]), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][0][0]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('firstExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.firstExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.giphyRandom
    },
    model: {
      value: (_vm.example.firstExample.response),
      callback: function($$v) {
        _vm.example.firstExample.response = $$v
      },
      expression: "example.firstExample.response"
    }
  }, [(_vm.example.firstExample.response.body) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.example.firstExample.response.body.data.image_url,
      "alt": "giphy"
    }
  }) : _vm._e()]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('h4', [_vm._v("Response")]), _vm._v(" "), _c('pre', [_vm._v("myResponse = " + _vm._s(_vm.example.firstExample.response))])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_2"
    }
  }, [_c('h3', [_vm._v("2. Request with Params")]), _vm._v(" "), _c('h4', [_vm._v("Simple parameter")]), _vm._v(" "), _c('p', [_vm._v("If you only need a unique param, all you need is:")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][1][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][1][1]))
    }
  }), _vm._v(" "), _c('h4', [_vm._v("Multiple parameters")]), _vm._v(" "), _c('p', [_vm._v("If you use more than one param, you have to use your param as an object:")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][1][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][1][3]))
    }
  }), _vm._v(" "), _vm._m(8)]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_3"
    }
  }, [_c('h3', [_vm._v("3. Fake Requests")]), _vm._v(" "), _vm._m(9), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][2][0]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('fakeExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.fakeExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(3000, 'My fake Request')
    },
    model: {
      value: (_vm.example.fakeExample.response),
      callback: function($$v) {
        _vm.example.fakeExample.response = $$v
      },
      expression: "example.fakeExample.response"
    }
  }, [_vm._v("\n                  Hello, I am a fake request and my response is: "), _c('code', [_vm._v(_vm._s(_vm.example.fakeExample.response))])]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_4"
    }
  }, [_c('h3', [_vm._v("4. Global Request Access from $api")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][3][0]))
    }
  }), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][3][1]))
    }
  }), _vm._v(" "), _vm._m(12), _vm._v(" "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][3][2]))
    }
  })]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_5"
    }
  }, [_c('h3', [_vm._v("5. Trigger & Sync Requests using Waiting Slot")]), _vm._v(" "), _vm._m(13), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15), _vm._v(" "), _c('h4', [_vm._v("Example with trigger.sync")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(17), _vm._v(" "), _c('p', [_vm._v("\n            If you have an older version, use\n            "), _c('strong', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods_fetch')
      }
    }
  }, [_vm._v("\n                fetch method\n              ")])]), _vm._v(".\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][4][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(18), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', [_c('a', {
    staticClass: "btn btn-default btn-lg",
    style: ({
      width: '120px'
    }),
    on: {
      "click": function($event) {
        _vm.example.likeExample.trigger = true
      }
    }
  }, [_c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, !_vm.example.likeExample.liked),
      "trigger": _vm.example.likeExample.trigger,
      "spinner-scale": 0.55,
      "spinner-padding": 0
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.likeExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.likeExample.liked),
      callback: function($$v) {
        _vm.example.likeExample.liked = $$v
      },
      expression: "example.likeExample.liked"
    }
  }, [_c('span', {
    slot: "waiting"
  }, [_vm._v("\n                    " + _vm._s(_vm.example.likeExample.liked ? 'You liked' : 'Like') + "\n                ")])])], 1)])])])])]), _vm._v(" "), _c('h4', [_vm._v("Example with sync and trigger.sync")]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][4][3]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('triggerExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', [(_vm.example.triggerExample.show) ? _c('api-request', {
    staticClass: "div-section",
    style: ({
      minHeight: '250px'
    }),
    attrs: {
      "resource": _vm.$api.giphySearch,
      "params": {
        q: _vm.example.triggerExample.q,
        offset: _vm.example.triggerExample.offset,
        limit: 3
      },
      "trigger": _vm.example.triggerExample.trigger,
      "sync": _vm.example.triggerExample.offset
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.triggerExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.triggerExample.response),
      callback: function($$v) {
        _vm.example.triggerExample.response = $$v
      },
      expression: "example.triggerExample.response"
    }
  }, [_c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.example.triggerExample.trigger = true
      }
    },
    slot: "waiting"
  }, [_c('div', {
    staticClass: "form-group col-xs-12 col-md-4 col-md-offset-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.triggerExample.q),
      expression: "example.triggerExample.q"
    }],
    staticClass: "form-control",
    attrs: {
      "placeholder": "Type something"
    },
    domProps: {
      "value": (_vm.example.triggerExample.q)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.triggerExample.q = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default"
  }, [_vm._v("Search")])])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [(_vm.example.triggerExample.response.body) ? _c('div', {
    staticClass: "row"
  }, _vm._l((_vm.example.triggerExample.response.body.data), function(item) {
    return _c('div', {
      staticClass: "col-md-4"
    }, [_c('img', {
      staticClass: "img-responsive",
      style: ({
        maxHeight: '250px'
      }),
      attrs: {
        "src": item.images.fixed_width.url,
        "alt": "giphy"
      }
    })])
  })) : _vm._e()]), _vm._v(" "), _c('div', {
    slot: "error"
  }, [_vm._v("\n                  Error loading this page!\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.example.triggerExample.response.body) ? _c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.triggerExample.offset -= _vm.example.triggerExample.offset == 0 ? 0 : 3
      }
    }
  }, [_vm._v("Previous")])]), _vm._v(" "), _c('li', [_vm._v("\n                  " + _vm._s(_vm.example.triggerExample.offset / 3 + 1) + "\n                ")]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.triggerExample.offset += 3
      }
    }
  }, [_vm._v("Next")])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_c('h4', [_vm._v("Multi variables in Sync")]), _vm._v(" "), _vm._m(20), _vm._v(" "), _vm._m(21), _vm._v(" "), _c('br'), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][4][4]))
    }
  })])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_6"
    }
  }, [_c('h3', [_vm._v("6. Conditional Request")]), _vm._v("\n\n        Conditional request gives you one more option to easily control your requests.\n\n        "), _c('h4', [_vm._v("Example")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][5][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][5][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(22), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('api-request', {
    attrs: {
      "resource": _vm.$api.giphyRandom,
      "trigger": _vm.example.conditionalExample.trigger,
      "only-if": _vm.example.conditionalExample.canRefresh
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.conditionalExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.conditionalExample.response),
      callback: function($$v) {
        _vm.example.conditionalExample.response = $$v
      },
      expression: "example.conditionalExample.response"
    }
  }, [_c('ul', {
    staticClass: "list-inline"
  }, [_c('li', [_c('div', {
    staticClass: "checkbox"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.conditionalExample.canRefresh),
      expression: "example.conditionalExample.canRefresh"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.example.conditionalExample.canRefresh) ? _vm._i(_vm.example.conditionalExample.canRefresh, null) > -1 : (_vm.example.conditionalExample.canRefresh)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.example.conditionalExample.canRefresh,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.example.conditionalExample.canRefresh = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.example.conditionalExample.canRefresh = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.example.conditionalExample.canRefresh = $$c
        }
      }
    }
  }), _vm._v(" Can Refresh\n                        ")])])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.conditionalExample.trigger = true
      }
    }
  }, [_vm._v("Refresh GIF")])])]), _vm._v(" "), (_vm.example.conditionalExample.response) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.example.conditionalExample.response.body.data.image_url,
      "alt": "giphy"
    }
  }) : _vm._e()])], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_7"
    }
  }, [_c('h3', [_vm._v("7. Using Events")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][6][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][6][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [(!_vm.example.eventsExample.show) ? _c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('eventsExample')
      }
    }
  }, [_vm._v("Reveal Example")]) : _vm._e()]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.eventsExample.show) ? _c('div', [_c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000),
      "trigger": _vm.example.eventsExample.triggerWaiting
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerWaiting = $event
      },
      "waiting": _vm.example.eventsExample.waiting
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerWaiting = true
      }
    }
  }, [_vm._v("Waiting Example")])])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000),
      "trigger": _vm.example.eventsExample.triggerLoading
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerLoading = $event
      },
      "loading": _vm.example.eventsExample.loading
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerLoading = true
      }
    }
  }, [_vm._v("Loading Example")])])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'successResp'),
      "trigger": _vm.example.eventsExample.triggerSuccess
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerSuccess = $event
      },
      "success": _vm.example.eventsExample.success
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerSuccess = true
      }
    }
  }, [_vm._v("Success Example")])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [_vm._v("Success")])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequestError(1000, 'errorResp'),
      "trigger": _vm.example.eventsExample.triggerError
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerError = $event
      },
      "error": _vm.example.eventsExample.error
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerError = true
      }
    }
  }, [_vm._v("Error Example")])]), _vm._v(" "), _c('div', {
    slot: "error"
  }, [_vm._v("Error")])]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'loadedResp'),
      "trigger": _vm.example.eventsExample.triggerLoaded
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.eventsExample.triggerLoaded = $event
      },
      "loaded": _vm.example.eventsExample.loaded
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.eventsExample.triggerLoaded = true
      }
    }
  }, [_vm._v("Loaded Example")])]), _vm._v(" "), _c('div', {
    slot: "loaded"
  }, [_vm._v("Loaded")])])], 1) : _vm._e()])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_8"
    }
  }, [_c('h3', [_vm._v("8. Serial Requests")]), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][7][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][7][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('serialExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.serialExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1000, 'First Response'),
      "trigger": _vm.example.serialExample.trigger,
      "effect": "flipInX"
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.serialExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.serialExample.response1),
      callback: function($$v) {
        _vm.example.serialExample.response1 = $$v
      },
      expression: "example.serialExample.response1"
    }
  }, [_c('div', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.serialExample.trigger = true
      }
    }
  }, [_vm._v("Do serial request")])]), _vm._v(" "), _c('div', {
    slot: "success"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response1))]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(1500, 'Second Response'),
      "effect": "flipInY"
    },
    model: {
      value: (_vm.example.serialExample.response2),
      callback: function($$v) {
        _vm.example.serialExample.response2 = $$v
      },
      expression: "example.serialExample.response2"
    }
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response2))]), _vm._v(" "), _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2000, 'Third Response'),
      "effect": "zoomIn"
    },
    model: {
      value: (_vm.example.serialExample.response3),
      callback: function($$v) {
        _vm.example.serialExample.response3 = $$v
      },
      expression: "example.serialExample.response3"
    }
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.serialExample.response3))])])], 1)], 1)]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_9"
    }
  }, [_c('h3', [_vm._v("9. Parallel Requests")]), _vm._v(" "), _vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][8][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][8][1]))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('parallelExample')
      }
    }
  }, [_vm._v("Reload Example")])]), _vm._v(" "), _c('h4', [_vm._v("Result")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.parallelExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.example.parallelExample.resource(_vm.$api),
      "trigger": _vm.example.parallelExample.trigger
    },
    on: {
      "update:trigger": function($event) {
        _vm.example.parallelExample.trigger = $event
      }
    },
    model: {
      value: (_vm.example.parallelExample.response),
      callback: function($$v) {
        _vm.example.parallelExample.response = $$v
      },
      expression: "example.parallelExample.response"
    }
  }, [_c('form', {
    slot: "waiting"
  }, [_c('a', {
    staticClass: "btn btn-default",
    on: {
      "click": function($event) {
        _vm.example.parallelExample.trigger = true
      }
    }
  }, [_vm._v("Do parallel request")])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    slot: "success"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request1))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request2))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('img', {
    style: ({
      width: '200px'
    }),
    attrs: {
      "src": "/static/v-api@512.png",
      "alt": "vue-api-request"
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.example.parallelExample.response.request3))])])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "exp_10"
    }
  }, [_c('h3', [_vm._v("10. Customize")]), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_vm._m(27), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [_c('div', {
    staticClass: "row free-customize"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-4 text-left"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-effect"
    }
  }, [_vm._v("Effect")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.effect),
      expression: "example.customizeExample.effect"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-effect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.example.customizeExample.effect = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "fadeIn"
    }
  }, [_vm._v("fadeIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fadeInDown"
    }
  }, [_vm._v("fadeInDown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "fadeInUp"
    }
  }, [_vm._v("fadeInUp")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomIn"
    }
  }, [_vm._v("zoomIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomInDown"
    }
  }, [_vm._v("zoomInDown")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "zoomInUp"
    }
  }, [_vm._v("zoomInUp")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bounceIn"
    }
  }, [_vm._v("bounceIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flipInX"
    }
  }, [_vm._v("flipInX")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flipInY"
    }
  }, [_vm._v("flipInY")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "lightSpeedIn"
    }
  }, [_vm._v("lightSpeedIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInDownLeft"
    }
  }, [_vm._v("rotateInDownLeft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInDownRight"
    }
  }, [_vm._v("rotateInDownRight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInUpLeft"
    }
  }, [_vm._v("rotateInUpLeft")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rotateInUpRight"
    }
  }, [_vm._v("rotateInUpRight")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rollIn"
    }
  }, [_vm._v("rollIn")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "bounce"
    }
  }, [_vm._v("bounce")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "flash"
    }
  }, [_vm._v("flash")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "pulse"
    }
  }, [_vm._v("pulse")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "rubberBand"
    }
  }, [_vm._v("rubberBand")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "shake"
    }
  }, [_vm._v("shake")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "swing"
    }
  }, [_vm._v("swing")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "tada"
    }
  }, [_vm._v("tada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "wobble"
    }
  }, [_vm._v("wobble")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "jello"
    }
  }, [_vm._v("jello")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner"
    }
  }, [_vm._v("Spinner")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinner),
      expression: "example.customizeExample.spinner"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.example.customizeExample.spinner = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "PulseLoader"
    }
  }, [_vm._v("PulseLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GridLoader"
    }
  }, [_vm._v("GridLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ClipLoader"
    }
  }, [_vm._v("ClipLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RiseLoader"
    }
  }, [_vm._v("RiseLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BeatLoader"
    }
  }, [_vm._v("BeatLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SyncLoader"
    }
  }, [_vm._v("SyncLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RotateLoader"
    }
  }, [_vm._v("RotateLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FadeLoader"
    }
  }, [_vm._v("FadeLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PacmanLoader"
    }
  }, [_vm._v("PacmanLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SquareLoader"
    }
  }, [_vm._v("SquareLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ScaleLoader"
    }
  }, [_vm._v("ScaleLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SkewLoader"
    }
  }, [_vm._v("SkewLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MoonLoader"
    }
  }, [_vm._v("MoonLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RingLoader"
    }
  }, [_vm._v("RingLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "BounceLoader"
    }
  }, [_vm._v("BounceLoader")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DotLoader"
    }
  }, [_vm._v("DotLoader")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-color"
    }
  }, [_vm._v("Spinner Color")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerColor),
      expression: "example.customizeExample.spinnerColor"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner-color"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerColor)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerColor = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-padding"
    }
  }, [_vm._v("Spinner Padding")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerPadding),
      expression: "example.customizeExample.spinnerPadding"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "customize-spinner-padding"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerPadding)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerPadding = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "customize-spinner-scale"
    }
  }, [_vm._v("Spinner Scale")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.example.customizeExample.spinnerScale),
      expression: "example.customizeExample.spinnerScale"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "min": "0",
      "max": "5",
      "id": "customize-spinner-scale"
    },
    domProps: {
      "value": (_vm.example.customizeExample.spinnerScale)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.example.customizeExample.spinnerScale = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-center"
  }, [_c('a', {
    staticClass: "btn btn-primary btn-lg",
    on: {
      "click": function($event) {
        _vm.reset('customizeExample', true)
      }
    }
  }, [_vm._v("Make")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4"
  }, [(_vm.example.customizeExample.show) ? _c('api-request', {
    style: ({
      maxWidth: '100%',
      marginBottom: '1em',
      border: '1px solid #ccc',
      position: 'relative',
      zIndex: '1'
    }),
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "effect": _vm.example.customizeExample.effect,
      "spinner": _vm.example.customizeExample.spinner,
      "spinner-color": _vm.example.customizeExample.spinnerColor,
      "spinner-padding": _vm.example.customizeExample.spinnerPadding,
      "spinner-scale": _vm.example.customizeExample.spinnerScale
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(16),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-4 text-left"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['freeCustomize']({
        effect: _vm.example.customizeExample.effect,
        spinner: _vm.example.customizeExample.spinner,
        spinnerColor: _vm.example.customizeExample.spinnerColor,
        spinnerPadding: _vm.example.customizeExample.spinnerPadding,
        spinnerScale: _vm.example.customizeExample.spinnerScale
      })))
    }
  })])])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "creating-effect"
    }
  }, [_vm._v("Creating your own effect")]), _vm._v(" "), _vm._m(28), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][9][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][1]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('customEffectExample')
      }
    }
  }, [_vm._v("Show Effect")])]), _vm._v(" "), _c('h4', [_vm._v("Example")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.customEffectExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(500),
      "effect": "blur"
    }
  }, [_c('img', {
    style: ({
      maxHeight: '200px',
      width: 'auto'
    }),
    attrs: {
      "src": __webpack_require__(16),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1)])])]), _vm._v(" "), _c('h4', {
    attrs: {
      "id": "creating-loader"
    }
  }, [_vm._v("Creating your own loader")]), _vm._v(" "), _vm._m(29), _vm._v(" "), _vm._m(30), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-8"
  }, [_c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][2]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("Setting your custom loader: ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['docs'][9][3]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['docs'][9][4]))
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('div', {
    staticClass: "panel panel-default panel-result"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('div', {
    staticClass: "pull-right"
  }, [_c('a', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.reset('customSpinnerExample')
      }
    }
  }, [_vm._v("Show Loader")])]), _vm._v(" "), _c('h4', [_vm._v("Example")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-body text-center"
  }, [(_vm.example.customSpinnerExample.show) ? _c('api-request', {
    attrs: {
      "resource": _vm.$api.fakeRequest(2500),
      "spinner": "CustomLoader"
    }
  }, [_c('img', {
    style: ({
      maxHeight: '200px',
      width: 'auto'
    }),
    attrs: {
      "src": __webpack_require__(16),
      "alt": "Vue Api Request"
    }
  })]) : _vm._e()], 1)])])])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "api"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', [_vm._v("API Reference")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "props"
    }
  }, [_c('h3', [_vm._v("Props")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(31), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(32), _vm._v(" "), _c('td', [_vm._v("Function || Object")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("none")]), _vm._v(" "), _c('td', [_vm._m(33), _vm._v(" "), _c('h5', [_vm._v("Single request")]), _vm._v(" "), _c('ul', [_c('li', [_vm._m(34), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][1]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                      For this example, the response will be:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][2]))
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Multiple Request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      Also called as parallel request, it can call multiples APIs at the same and it only load when all APIs emit response.\n                      For this case, it has to be an "), _c('code', [_vm._v("Object")]), _vm._v(" whose its keys values need to be a "), _c('code', [_vm._v("Function")]), _vm._v("\n                      that returns a "), _c('code', [_vm._v("Promise")]), _vm._v(".\n                      See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_9')
      }
    }
  }, [_vm._v("Parallel Requests")]), _vm._v(" section for details.\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][3]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['resource'][4]))
    }
  }), _vm._v(" "), _c('p', [_vm._v("\n                      For this example, the response will be:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resource'][5]))
    }
  })])])])]), _vm._v(" "), _c('tr', [_vm._m(35), _vm._v(" "), _c('td', [_vm._v("any")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("null")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  If your resource functions have parameters, you can set here.\n                  See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_2')
      }
    }
  }, [_vm._v("Request with Params")]), _vm._v(" section for details.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Single request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      See example below:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['params'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['params'][1]))
    }
  })])]), _vm._v(" "), _c('h5', [_vm._v("Multiple request")]), _vm._v(" "), _c('ul', [_c('li', [_c('p', [_vm._v("\n                      See example below:\n                    ")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['params'][2]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['props']['params'][3]))
    }
  })])])])]), _vm._v(" "), _vm._m(36), _vm._v(" "), _c('tr', [_vm._m(37), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("false")]), _vm._v(" "), _c('td', [_vm._m(38), _vm._v(" "), _c('div', {
    staticClass: "alert alert-info"
  }, [_vm._m(39), _vm._v(" "), _c('p', [_vm._v("\n                    If you have an older version, use\n                    "), _c('strong', [_c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#methods_fetch')
      }
    }
  }, [_vm._v("\n                        fetch method\n                      ")])]), _vm._v(".\n                  ")])])])]), _vm._v(" "), _vm._m(40), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('tr', [_vm._m(42), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('td', [_vm._m(44), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.js(_vm.code['apiReference']['props']['resp'][0]))
    }
  }), _vm._v(" "), _vm._m(45), _vm._v(" "), _vm._m(46), _vm._v(" "), _vm._m(47)])]), _vm._v(" "), _vm._m(48), _vm._v(" "), _vm._m(49), _vm._v(" "), _vm._m(50), _vm._v(" "), _vm._m(51)])])])]), _vm._v(" "), _vm._m(52), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "slots"
    }
  }, [_c('h3', [_vm._v("Slots")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(53), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(54), _vm._v(" "), _c('td', [_vm._m(55), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['default'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['default'][1]))
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(56), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from the component is waiting to be call.\n                ")]), _vm._v(" "), _vm._m(57), _vm._v(" "), _vm._m(58), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['waiting'][0]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['slots']['waiting'][1]))
    }
  })])]), _vm._v(" "), _c('tr', [_vm._m(59), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Replaces the standard loader and shows your custom loader.\n                  See also "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#conf-methods')
      }
    }
  }, [_vm._v("addLoader")]), _vm._v(" method.\n                ")])])]), _vm._v(" "), _vm._m(60), _vm._v(" "), _vm._m(61), _vm._v(" "), _vm._m(62)])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "methods"
    }
  }, [_c('h3', [_vm._v("Methods")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(63), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "id": "methods_fetch"
    }
  }, [_vm._m(64), _vm._v(" "), _vm._m(65), _vm._v(" "), _c('td', [_vm._v("\n                It calls the target API(s) instantly.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _vm._m(66), _vm._v(" "), _c('h5', [_vm._v("Example")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][0]))
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Example using key param")]), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][1]))
    }
  }), _vm._v(" "), _c('pre', {
    domProps: {
      "innerHTML": _vm._s(_vm.html(_vm.code['apiReference']['methods']['fetch'][2]))
    }
  })])])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "conf-methods"
    }
  }, [_c('h3', [_vm._v("Configuration Methods")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(67), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(68), _vm._v(" "), _vm._m(69), _vm._v(" "), _c('td', [_vm._v("\n                It will set the global "), _c('code', [_vm._v("$api")]), _vm._v(" variable.\n                See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#exp_4')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _vm._m(70)])]), _vm._v(" "), _c('tr', [_vm._m(71), _vm._v(" "), _vm._m(72), _vm._v(" "), _c('td', [_vm._v("\n                Add a custom effect.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_vm._m(73), _vm._v(" "), _c('li', [_c('code', [_vm._v("effect")]), _vm._v(": Function that makes the the effect.\n                    See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#creating-effect')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                  ")])])])]), _vm._v(" "), _c('tr', [_vm._m(74), _vm._v(" "), _vm._m(75), _vm._v(" "), _c('td', [_vm._v("\n                Add a custom loader.\n                "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_vm._m(76), _vm._v(" "), _c('li', [_c('code', [_vm._v("component")]), _vm._v(": Component that will be used as loader.\n                    See "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#creating-loader')
      }
    }
  }, [_vm._v("this example")]), _vm._v(".\n                  ")])])])])])])])]), _vm._v(" "), _c('fieldset', {
    attrs: {
      "id": "conf-options"
    }
  }, [_c('h3', [_vm._v("Configuration Options")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_vm._m(77), _vm._v(" "), _c('tbody', [_c('tr', [_vm._m(78), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("effect")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(79), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("resp")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(80), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(81), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-color")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(82), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-padding")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(83), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#props')
      }
    }
  }, [_vm._v("spinner-scale")]), _vm._v(" props.\n                  "), _c('br'), _vm._v("\n                  Props will replace if it is set.\n                ")])])]), _vm._v(" "), _c('tr', [_vm._m(84), _vm._v(" "), _vm._m(85), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("@success")]), _vm._v(" event.\n                ")]), _vm._v(" "), _vm._m(86)])]), _vm._v(" "), _c('tr', [_vm._m(87), _vm._v(" "), _vm._m(88), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Same as "), _c('a', {
    on: {
      "click": function($event) {
        _vm.scrollTo('#events')
      }
    }
  }, [_vm._v("@error")]), _vm._v(" event.\n                ")]), _vm._v(" "), _vm._m(89)])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Package is installable via "), _c('strong', [_vm._v("NPM")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          via "), _c('strong', [_vm._v("Yarn")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("or")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          via "), _c('strong', [_vm._v("CDN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          It will set "), _c('code', [_vm._v("window.VueApiRequest")]), _vm._v(" as the module.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    attrs: {
      "href": "https://jsfiddle.net/gibranmax/everjv20/",
      "target": "_blank"
    }
  }, [_vm._v("See example in JSFiddle")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          In the first example, we gonna use a public API provided by\n          "), _c('a', {
    attrs: {
      "href": "https://developers.giphy.com/docs/",
      "target": "_blank"
    }
  }, [_vm._v("Giphy")]), _vm._v("\n          which will generate a random Gif every time\n          the component is mounted. Check it out:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('h4', [_vm._v("Never do this, ever!")]), _vm._v(" "), _c('p', [_vm._v("\n            Normally, if you need params, you call the function like: "), _c('code', [_vm._v("func(a, b)")]), _vm._v(". However, using this concept\n            in "), _c('code', [_vm._v(":resource=\"giphyRandom('food', 'g')\"")]), _vm._v(", the component will not work properly.\n          ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Remind:")]), _vm._v(" The component requires a "), _c('code', [_vm._v("Function")]), _vm._v(" in "), _c('code', [_vm._v("resource")]), _vm._v(",\n            not its "), _c('code', [_vm._v("Promise Object")]), _vm._v(".\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Fake requests are useful for testing and other occasions.\n          You only need to create a "), _c('code', [_vm._v("Promise")]), _vm._v(" with "), _c('code', [_vm._v("setTimeout")]), _vm._v("\n          and return it in a function. See the example below:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          It is possible to set global all your API Requests. To do this, let us create a new file "), _c('code', [_vm._v("api.js")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Here we import "), _c('code', [_vm._v("api.js")]), _vm._v(" and set it in VueApiRequest\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Now you have your APIs stored in the global variable "), _c('code', [_vm._v("$api")]), _vm._v(". To use it, follow the example:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" is very useful.\n          It keeps component in a standby state, holding the call.\n          So, you are allowed to call your API whenever you want by using "), _c('code', [_vm._v("sync")]), _vm._v(", "), _c('code', [_vm._v("trigger")]), _vm._v(" or "), _c('code', [_vm._v("fetch method")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          By default, if you don't have "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" or "), _c('code', [_vm._v("Success Slot")]), _vm._v(" set,\n          the "), _c('code', [_vm._v("Default Slot")]), _vm._v(" will be "), _c('code', [_vm._v("Success Slot")]), _vm._v("\n          and the component will not hold the API call (the call happens when the component is mounted).\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Other case, if there is only "), _c('code', [_vm._v("Waiting Slot")]), _vm._v(" set, the component will come back to this slot after the request is done (loaded).\n          This is can be useful for some situations like "), _c('strong', [_vm._v("toggle requests")]), _vm._v(" (e.g. Like Button).\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("trigger.sync")]), _vm._v(" parameter calls the API when its value is set to "), _c('strong', [_vm._v("true")]), _vm._v(".\n          After the call, this variable changes to "), _c('strong', [_vm._v("false")]), _vm._v(" automatically.\n          "), _c('br'), _vm._v("\n          In the first example, it shows you how to use "), _c('code', [_vm._v("trigger.sync")]), _vm._v(" by using like button.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Trigger.sync")]), _vm._v(" is only available in Vue 2.3.0+")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The "), _c('code', [_vm._v("sync")]), _vm._v(" parameter calls the API whenever its value changes.\n          "), _c('br'), _vm._v("\n          The next example is a "), _c('strong', [_vm._v("search query gif")]), _vm._v(" with pagination,\n          using "), _c('code', [_vm._v("sync")]), _vm._v(" and "), _c('code', [_vm._v("trigger.sync")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            For an unknown reason, you can't simply sync multi variables like this: "), _c('code', [_vm._v(":sync=\"[foo, bar]\"")]), _vm._v(".\n            It causes a weird bug which treats sync parameter as reactive with input event.\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n            A good solution is to use computed variable in sync parameter.\n            The example below you can use "), _c('code', [_vm._v(":sync=\"foobar\"")]), _vm._v(":\n          ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Result")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Sometimes you need more than one request. There are many options to handle with that.\n          One way is to make "), _c('code', [_vm._v("Serial Requests")]), _vm._v(" which is basically stacks of requests.\n          It can be useful if one of request needs the data of the other one.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The example below loads three queue requests from "), _c('code', [_vm._v("fakeRequest")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          If some content uses data of many of requests, "), _c('code', [_vm._v("Parallel Requests")]), _vm._v(" can save you.\n          By this way, the content only shows when all of set of requests are successfully loaded.\n          Otherwise, it throws an error.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          This example is the same as "), _c('code', [_vm._v("Serial Requests")]), _vm._v(" showed before, but now all responses\n          appear at the same time when all of them load.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h4', [_vm._v("Free customize")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          Using "), _c('code', [_vm._v("addEffect")]), _vm._v(" method, it is possible to create a new effect.\n          "), _c('a', {
    attrs: {
      "href": "//greensock.com"
    }
  }, [_vm._v("GreenSock")]), _vm._v(" provides a good way to customize your effect animation,\n          and it will be used in the next example:\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          You may also create your custom loader.\n          There are two ways: using "), _c('code', [_vm._v("addLoader")]), _vm._v(" method or using "), _c('code', [_vm._v("Loading Slot")]), _vm._v(".\n          The first option is more recommended.\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n          The next example uses "), _c('code', [_vm._v("addLoader")]), _vm._v(" method, applying\n          "), _c('a', {
    attrs: {
      "href": "//fontawesome.io"
    }
  }, [_vm._v("Font Awesome")]), _vm._v(" as a custom spinner.\n          We gonna create a new component called "), _c('code', [_vm._v("CustomLoader.vue")]), _vm._v(":\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Default")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resource")]), _c('strong', {
    staticClass: "grey"
  }, [_vm._v("(required)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  This is where you set your API. It can be "), _c('code', [_vm._v("single request")]), _vm._v("\n                  or "), _c('code', [_vm._v("multiple request")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                      This is usually the most used. For this case, it has to be a "), _c('code', [_vm._v("Function")]), _vm._v("\n                      that returns a "), _c('code', [_vm._v("Promise")]), _vm._v(".\n                    ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("params")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("sync")])]), _vm._v(" "), _c('td', [_vm._v("any")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("null")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  It calls API whenever it changes its value.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("trigger.sync")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  It calls API whenever it is set to "), _c('strong', [_vm._v("true")]), _vm._v(".\n                  It is automatically set to "), _c('strong', [_vm._v("false")]), _vm._v(" after the call.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Trigger.sync")]), _vm._v(" is only available in Vue 2.3.0+")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("only-if")])]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("true")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Your API is called only if this parameter is "), _c('strong', [_vm._v("true")]), _vm._v(".\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("effect")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("fadeIn")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  The effect to be shown when the content is loaded.\n                  These effects are provided by\n                  "), _c('a', {
    attrs: {
      "href": "https://daneden.github.io/animate.css/",
      "target": "_blank"
    }
  }, [_vm._v("Animate.css")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Recommended Effects:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_vm._v("fadeIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("fadeInDown")]), _vm._v(",\n                  "), _c('code', [_vm._v("fadeInUp")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomInDown")]), _vm._v(",\n                  "), _c('code', [_vm._v("zoomInUp")]), _vm._v(",\n                  "), _c('code', [_vm._v("bounceIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("flipInX")]), _vm._v(",\n                  "), _c('code', [_vm._v("flipInY")]), _vm._v(",\n                  "), _c('code', [_vm._v("lightSpeedIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInDownLeft")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInDownRight")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInUpLeft")]), _vm._v(",\n                  "), _c('code', [_vm._v("rotateInUpRight")]), _vm._v(",\n                  "), _c('code', [_vm._v("rollIn")]), _vm._v(",\n                  "), _c('code', [_vm._v("bounce")]), _vm._v(",\n                  "), _c('code', [_vm._v("flash")]), _vm._v(",\n                  "), _c('code', [_vm._v("pulse")]), _vm._v(",\n                  "), _c('code', [_vm._v("rubberBand")]), _vm._v(",\n                  "), _c('code', [_vm._v("shake")]), _vm._v(",\n                  "), _c('code', [_vm._v("swing")]), _vm._v(",\n                  "), _c('code', [_vm._v("tada")]), _vm._v(",\n                  "), _c('code', [_vm._v("wobble")]), _vm._v(",\n                  "), _c('code', [_vm._v("jello")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    staticClass: "grey"
  }, [_vm._v(". "), _c('strong', [_vm._v("(dot)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  Path of response data. Imagine this "), _c('strong', [_vm._v("response")]), _vm._v(":\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  if "), _c('code', [_vm._v("resp=\"foo\"")]), _vm._v(", the response is actually "), _c('code', [_vm._v("response.foo")]), _vm._v(".\n                  "), _c('br'), _vm._v("\n                  if "), _c('code', [_vm._v("resp=\"foo.bar\"")]), _vm._v(", the response is actually "), _c('code', [_vm._v("response.foo.bar")]), _vm._v(".\n                  "), _c('br'), _vm._v("\n                  if "), _c('code', [_vm._v("resp=\".\"")]), _vm._v(", the response keeps in "), _c('code', [_vm._v("response")]), _vm._v(".\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  For "), _c('strong', [_vm._v("Vue Resource")]), _vm._v(" calls, this is usually set to "), _c('code', [_vm._v("body")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  For "), _c('strong', [_vm._v("axios")]), _vm._v(" calls, this is usually set to "), _c('code', [_vm._v("data")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("ClipLoader")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  The spinner to be shown when the content is loading.\n                  These spinners is provided by\n                  "), _c('a', {
    attrs: {
      "href": "http://greyby.github.io/vue-spinner/",
      "target": "_blank"
    }
  }, [_vm._v("greyby.github.io/vue-spinner/")]), _vm._v(".\n                ")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Available Spinners:")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('code', [_vm._v("PulseLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("GridLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("ClipLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RiseLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("BeatLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SyncLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RotateLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("FadeLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("PacmanLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SquareLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("ScaleLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("SkewLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("MoonLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("RingLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("BounceLoader")]), _vm._v(",\n                  "), _c('code', [_vm._v("DotLoader")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-color")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("#42b983")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Hex color of Spinner.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-padding")])]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1em")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("Padding of Spinner.")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("spinner-scale")])]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', {
    staticClass: "grey"
  }, [_vm._v("1")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Size of Spinner. The value "), _c('code', [_vm._v("1")]), _vm._v("\n                  means its size is 100% of its original size.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('fieldset', {
    attrs: {
      "id": "events"
    }
  }, [_c('h3', [_vm._v("Events")]), _vm._v(" "), _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_c('code', [_vm._v("@waiting")])]), _vm._v(" "), _c('td', [_vm._v("none")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from the component is waiting to be call.\n                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@loading")])]), _vm._v(" "), _c('td', [_vm._v("none")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from the component is loading.\n                ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@success")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a success response.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@error")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a error response.\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('code', [_vm._v("@loaded")])]), _vm._v(" "), _c('td', [_vm._v("response")]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  Emits when the API from component returns a response (success or error).\n                ")]), _vm._v(" "), _c('h5', [_vm._v("Params")]), _vm._v(" "), _c('ul', [_c('li', [_c('code', [_vm._v("response")]), _vm._v(": API response.\n                  ")])])])])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("default")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\n                  If there is no "), _c('code', [_vm._v("success slot")]), _vm._v(" or "), _c('code', [_vm._v("waiting slot")]), _vm._v(",\n                  it corresponds the "), _c('code', [_vm._v("success slot")]), _vm._v(".\n                  Otherwise, it is disabled.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("waiting")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v("\n                  if the "), _c('code', [_vm._v("waiting slot")]), _vm._v("\n                  slot is set, the component keeps its waiting state until you fetch it.\n                  Otherwise, the component automatically fetches it.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v("\n                  if there is no "), _c('code', [_vm._v("success slot")]), _vm._v(", "), _c('code', [_vm._v("error slot")]), _vm._v(" or "), _c('code', [_vm._v("loaded slot")]), _vm._v(", the state of the component will return to "), _c('code', [_vm._v("waiting")]), _vm._v("\n                  after it fetches and loaded.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("loading")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("success")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a success response.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("error")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a error response.\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', [_c('code', [_vm._v("loaded")])]), _vm._v(" "), _c('td', [_c('p', [_vm._v("\n                  This content is shown when the API from component returns a response ("), _c('code', [_vm._v("success")]), _vm._v(" or "), _c('code', [_vm._v("error")]), _vm._v(").\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("fetch")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" key")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("key")]), _vm._v(": Name of API in the list to be call. If this parameter is not set, it will call all the APIs from the list.\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Parameters")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("setAPI")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("Object")]), _vm._v(" api")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_c('code', [_vm._v("api")]), _vm._v(": Object to be set\n                  ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("addEffect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" name, "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("Function")]), _vm._v(" effect")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("name")]), _vm._v(": Name of effect. It will replace if it already exists.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("addLoader")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('span', {
    staticClass: "grey"
  }, [_vm._v("String")]), _vm._v(" name, "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("Component")]), _vm._v(" component")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('code', [_vm._v("name")]), _vm._v(": Name of loader. It will replace if it already exists.\n                  ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Description")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("effect")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("resp")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerColor")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerPadding")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("spinnerScale")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("onSuccess")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Function "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("(response)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v(" "), _c('code', [_vm._v("@success")]), _vm._v(" do not replace this event. Both two are executed in this case.\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('code', [_vm._v("onError")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_vm._v("Function "), _c('span', {
    staticClass: "grey"
  }, [_vm._v("(response)")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                    Note:\n                  ")]), _vm._v(" "), _c('code', [_vm._v("@error")]), _vm._v(" do not replace this event. Both two are executed in this case.\n                ")])
}]}

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-pulse v-pulse1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-pulse v-pulse2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pulse v-pulse3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 171 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cross-domain-callback"
  }, [_c('div', {
    staticClass: "container text-left"
  }, [_c('h4', [_vm._v("Local do iFrame: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.local))]), _vm._v(" "), _c('h4', [_vm._v("Origem dos dados: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.origin))]), _vm._v(" "), _c('h4', [_vm._v("Dados recebidos: ")]), _vm._v(" "), _c('pre', [_vm._v(_vm._s(_vm.data))])])])
},staticRenderFns: []}

/***/ }),
/* 172 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner",
    style: ({
      position: 'relative',
      fontSize: 0
    })
  }, [_c('div', {
    staticClass: "v-pacman v-pacman1",
    style: (_vm.spinnerStyle1)
  }), _c('div', {
    staticClass: "v-pacman v-pacman2",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-pacman v-pacman3",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.spinnerDelay3])
  }), _c('div', {
    staticClass: "v-pacman v-pacman4",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.spinnerDelay4])
  }), _c('div', {
    staticClass: "v-pacman v-pacman5",
    style: ([_vm.spinnerStyle, _vm.animationStyle, _vm.spinnerDelay5])
  })])
},staticRenderFns: []}

/***/ }),
/* 173 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: ({
      color: this.color
    })
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin"
  }), _vm._v(" "), _c('strong', [_vm._v("LOADING...")])])
},staticRenderFns: []}

/***/ }),
/* 174 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-moon v-moon1",
    style: (_vm.spinnerStyle)
  }, [_c('div', {
    staticClass: "v-moon v-moon2",
    style: ([_vm.spinnerMoonStyle, _vm.animationStyle2])
  }), _c('div', {
    staticClass: "v-moon v-moon3",
    style: ([_vm.spinnerStyle, _vm.animationStyle3])
  })])])
},staticRenderFns: []}

/***/ }),
/* 175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-clip",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 176 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-beat v-beat-odd",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-beat v-beat-even",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-beat v-beat-odd",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 177 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner",
    style: ({
      position: 'relative',
      fontSize: 0
    })
  }, [_c('div', {
    staticClass: "v-fade v-fade1",
    style: ([_vm.spinnerStyle, _vm.animationStyle1])
  }), _c('div', {
    staticClass: "v-fade v-fade2",
    style: ([_vm.spinnerStyle, _vm.animationStyle2])
  }), _c('div', {
    staticClass: "v-fade v-fade3",
    style: ([_vm.spinnerStyle, _vm.animationStyle3])
  }), _c('div', {
    staticClass: "v-fade v-fade4",
    style: ([_vm.spinnerStyle, _vm.animationStyle4])
  }), _c('div', {
    staticClass: "v-fade v-fade5",
    style: ([_vm.spinnerStyle, _vm.animationStyle5])
  }), _c('div', {
    staticClass: "v-fade v-fade6",
    style: ([_vm.spinnerStyle, _vm.animationStyle6])
  }), _c('div', {
    staticClass: "v-fade v-fade7",
    style: ([_vm.spinnerStyle, _vm.animationStyle7])
  }), _c('div', {
    staticClass: "v-fade v-fade8",
    style: ([_vm.spinnerStyle, _vm.animationStyle8])
  })])
},staticRenderFns: []}

/***/ }),
/* 178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-dot v-dot1",
    style: (_vm.spinnerBasicStyle)
  }, [_c('div', {
    staticClass: "v-dot v-dot2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-dot v-dot3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-sync v-sync1",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay1])
  }), _c('div', {
    staticClass: "v-sync v-sync2",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay2])
  }), _c('div', {
    staticClass: "v-sync v-sync3",
    style: ([_vm.spinnerStyle, _vm.spinnerDelay3])
  })])
},staticRenderFns: []}

/***/ }),
/* 180 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-square",
    style: (_vm.spinnerStyle)
  })])
},staticRenderFns: []}

/***/ }),
/* 181 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "v-spinner"
  }, [_c('div', {
    staticClass: "v-bounce v-bounce1",
    style: (_vm.spinnerBasicStyle)
  }, [_c('div', {
    staticClass: "v-bounce v-bounce2",
    style: (_vm.spinnerStyle)
  }), _c('div', {
    staticClass: "v-bounce v-bounce3",
    style: (_vm.spinnerStyle)
  })])])
},staticRenderFns: []}

/***/ }),
/* 183 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "api-request",
    class: [_vm.animate]
  }, [(_vm.state == 'loading' && !_vm.hasLoadingSlot) ? _c('div', {
    staticClass: "spinner",
    style: ({
      padding: _vm.spinnerPadding,
      zoom: _vm.spinnerScale
    })
  }, [(_vm.spinner !== 'none') ? _c(_vm.spinner, {
    tag: "component",
    attrs: {
      "color": _vm.spinnerColor
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.state == 'loading') ? _vm._t("loading") : _vm._e(), _vm._v(" "), (_vm.state == 'waiting') ? _vm._t("waiting") : _vm._e(), _vm._v(" "), (_vm.state == 'success') ? _vm._t("success") : _vm._e(), _vm._v(" "), (_vm.state == 'error') ? _vm._t("error") : _vm._e(), _vm._v(" "), (_vm.state == 'success' || _vm.state == 'error') ? _vm._t("loaded") : _vm._e(), _vm._v(" "), (_vm.state == 'success' && !_vm.hasWaitingSlot && !_vm.hasSuccessSlot) ? _vm._t("default") : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */
/***/ (function(module, exports) {

module.exports = {"name":"ftgibran","version":"1.0.7","description":"My personal webpage <ftgibran>","author":"Felipe Gibran Eleuterio Toledo <ft.gibran@gmail.com>","private":true,"scripts":{"dev":"node build/dev-server.js","start":"node build/dev-server.js","build":"node build/build.js","unit":"cross-env BABEL_ENV=test karma start test/unit/karma.conf.js --single-run","e2e":"node test/e2e/runner.js","test":"npm run unit && npm run e2e","lint":"eslint --ext .js,.vue src test/unit/specs test/e2e/specs"},"dependencies":{"axios":"^0.16.2","bootstrap-sass":"^3.3.7","font-awesome":"^4.7.0","gsap":"^1.20.2","prismjs":"^1.6.0","vue":"^2.4.2","vue-analytics":"^4.3.1","vue-api-request":"^1.1.6","vue-head":"^2.0.11","vue-resource":"^1.3.4","vue-router":"^2.6.0"},"devDependencies":{"autoprefixer":"^7.1.2","babel-core":"^6.22.1","babel-eslint":"^7.1.1","babel-loader":"^7.1.1","babel-plugin-istanbul":"^4.1.1","babel-plugin-transform-runtime":"^6.22.0","babel-preset-env":"^1.3.2","babel-preset-stage-2":"^6.22.0","babel-register":"^6.22.0","chai":"^3.5.0","chalk":"^2.0.1","chromedriver":"^2.27.2","connect-history-api-fallback":"^1.3.0","copy-webpack-plugin":"^4.0.1","cross-env":"^5.0.1","cross-spawn":"^5.0.1","css-loader":"^0.28.0","cssnano":"^3.10.0","eslint":"^3.19.0","eslint-config-standard":"^6.2.1","eslint-friendly-formatter":"^3.0.0","eslint-loader":"^1.7.1","eslint-plugin-html":"^3.0.0","eslint-plugin-promise":"^3.4.0","eslint-plugin-standard":"^2.0.1","eventsource-polyfill":"^0.9.6","express":"^4.14.1","extract-text-webpack-plugin":"^2.0.0","file-loader":"^0.11.1","friendly-errors-webpack-plugin":"^1.1.3","html-webpack-plugin":"^2.28.0","http-proxy-middleware":"^0.17.3","inject-loader":"^3.0.0","karma":"^1.4.1","karma-coverage":"^1.1.1","karma-mocha":"^1.3.0","karma-phantomjs-launcher":"^1.0.2","karma-phantomjs-shim":"^1.4.0","karma-sinon-chai":"^1.3.1","karma-sourcemap-loader":"^0.3.7","karma-spec-reporter":"0.0.31","karma-webpack":"^2.0.2","lolex":"^1.5.2","mocha":"^3.2.0","nightwatch":"^0.9.12","node-sass":"^4.5.3","opn":"^5.1.0","optimize-css-assets-webpack-plugin":"^2.0.0","ora":"^1.2.0","phantomjs-prebuilt":"^2.1.14","rimraf":"^2.6.0","sass-loader":"^6.0.6","selenium-server":"^3.0.1","semver":"^5.3.0","shelljs":"^0.7.6","sinon":"^2.1.0","sinon-chai":"^2.8.0","url-loader":"^0.5.8","vue-loader":"^12.1.0","vue-style-loader":"^3.0.1","vue-template-compiler":"^2.3.3","webpack":"^2.6.1","webpack-bundle-analyzer":"^2.2.1","webpack-dev-middleware":"^1.10.0","webpack-hot-middleware":"^2.18.0","webpack-merge":"^4.1.0"},"engines":{"node":">= 4.0.0","npm":">= 3.0.0"},"browserslist":["> 1%","last 2 versions","not ie <= 8"]}

/***/ }),
/* 188 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[60]);


// WEBPACK FOOTER //
// dist/js/app.81cfa2999ff00ab59cd8.js